import React from 'react';
import { createBrowserRouter } from 'react-router-dom';

// Pages
import Root from './Root';

import Account from '../pages/account';

import ForgotPasswordRequest from '../pages/auth/forgot-password/request';
import ForgotPassword from '../pages/auth/forgot-password';
import Login from '../pages/auth/login';
import CreateAccount from '../pages/auth/create-account';
import Welcome from '../pages/auth/welcome';
import ValidateEmail from '../pages/auth/validate-email';

import Home from '../pages/home';
import Challenge from '../pages/challenge/[id]';
import Event from '../pages/event/[id]';
import Leaderboard from '../pages/leaderboard';
import Photos from '../pages/photos';
import Survey from '../pages/survey/[id]';

import HomeRedirect from './HomeRedirect';

export default createBrowserRouter([
  {
    path: "/",
    element: <Root />,
    errorElement: <div>Page not found</div>,
    children: [
      {
        path: '/',
        element: <HomeRedirect />,
      },

      // Account
      {
        path: '/account',
        element: <Account />,
      },

      // Auth
      {
        path: '/auth/forgot-password/request',
        element: <ForgotPasswordRequest />,
      },
      {
        path: '/auth/forgot-password/:token',
        element: <ForgotPassword />,
      },
      {
        path: '/auth/login',
        element: <Login />,
      },
      {
        path: '/auth/create-account',
        element: <CreateAccount />,
      },
      {
        path: '/auth/welcome',
        element: <Welcome />,
      },
      {
        path: '/auth/validate-email/:token',
        element: <ValidateEmail />,
      },

      // Home
      {
        path: '/home',
        element: <Home />,
      },
      {
        path: '/challenge/:id',
        element: <Challenge />,
      },
      {
        path: '/event/:id',
        element: <Event />,
      },
      {
        path: '/leaderboard',
        element: <Leaderboard />,
      },
      {
        path: '/photos',
        element: <Photos />,
      },
      {
        path: '/survey/:id',
        element: <Survey />,
      }
    ]
  }
]);